import {Image} from 'platform/foundation';

import {AdServer} from '../../../types/AdServer';

/** Spacing-scale caps; the wordmark scales down to fit the row without stretching it. */
const LOGO_MAX_HEIGHT = 4;
const LOGO_MAX_WIDTH = 16;

interface AdServerLogoProps {
  adServer: string;
}

/** Wordmark logo of an advertisement server (SVG, except Volvo Selekt which is a PNG). */
export function AdServerLogo(props: AdServerLogoProps) {
  const extension = props.adServer === AdServer.VOLVO_SELEKT ? 'png' : 'svg';

  return (
    <Image
      src={`/assets/images/ad-server-logo/${props.adServer}.${extension}`}
      maxHeight={LOGO_MAX_HEIGHT}
      maxWidth={LOGO_MAX_WIDTH}
      fit="contain"
      position="left"
    />
  );
}
